import Vue from "vue";
import Router from "vue-router";
import RootLayout from "./views/Layout/index.vue";
import Login from "@/views/Login";
import Register from "@/views/register";

// Test View
import Task from "@/views/task/index.vue";
import Test from "@/views/test/index.vue";
import audioWebTest from "@/views/test/audioWebTest.vue";
import imageTest from "@/views/test/imageTest.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/task",
      meta: {
        requiresAuth: true
      }
    },
    /*{
    path: '/imageTest',
    component: imageTest,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/test',
    component: Test,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audioWebTest',
    component: audioWebTest,
    meta: {
      requiresAuth: true,
    },
  },*/
    {
      path: "/task",
      component: RootLayout,
      children: [
        {
          path: "/",
          name: "task",
          component: Task,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/sleep_main",
          name: "LabelSleepMain",
          component: () => import("./views/task/sleep_main"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/sleep_main/:type/:batch_date",
          name: "CorrectSleepMain",
          component: () => import("./views/task/sleep_main"),
          meta: {
            requiresAuth: true
          },
          props: true
        },
        {
          path: "/task/audio",
          name: "LabelAudio",
          component: () => import("./views/task/audio"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/audio_v2",
          name: "LabelAudioV2",
          component: () => import("./views/task/audio_v2"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/sleep_occl",
          name: "sleepOcclusion",
          component: () => import("./views/task/sleep_occl"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/correct/sleep_occl/:batch_date",
          name: "CorrectSleepOccl",
          component: () => import("./views/task/sleep_occl/correct.vue"),
          meta: {
            requiresAuth: true
          },
          props: true
        },
        {
          path: "/task/sleep_detection",
          name: "SleepDetection",
          component: () => import("./views/task/sleep_detection"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/correct/sleep_detection/:batch_date",
          name: "CorrectSleepDetection",
          component: () => import("./views/task/sleep_detection/correct.vue"),
          meta: {
            requiresAuth: true
          },
          props: true
        },
        {
          path: "/task/caregiver",
          name: "Caregiver",
          component: () => import("./views/task/caregiver"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/task/live_main",
          name: "live_main",
          component: () => import("./views/task/live"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/check",
      component: RootLayout,
      props: true,
      children: [
        {
          path: "/",
          name: "check toolset",
          component: () => import("./views/check"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/check/sleep/feedback",
          name: "check sleep feedback",
          component: () => import("./views/check/sleep/feedback.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/check/sleep/records",
          name: "check sleep records",
          component: () => import("./views/check/sleep/records.vue"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/report",
      component: RootLayout,
      children: [
        {
          path: "/",
          name: "model report",
          component: () => import("./views/report"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/account",
      component: RootLayout,
      children: [
        {
          path: "/",
          name: "account manage",
          component: () => import("./views/account"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/dataset",
      component: RootLayout,
      children: [
        {
          path: "/",
          name: "dataset manage",
          component: () => import("./views/dataset"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/review/sleep_main/:batch_date",
          name: "review_sleep_main",
          component: () => import("./views/dataset/review/sleep_main"),
          meta: {
            requiresAuth: true
          },
          props: true
        },
        {
          path: "/review/sleep_occl/:batch_date",
          name: "review_sleep_occl",
          component: () => import("./views/dataset/review/sleep_occl"),
          meta: {
            requiresAuth: true
          },
          props: true
        },
        {
          path: "/review/sleep_detection/:batch_date",
          name: "review_sleep_detection",
          component: () => import("./views/dataset/review/sleep_detection"),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    }
  ]
});
